import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import UserFooter from "./UserFooter";
import Header from "./Header";
import AttachmentViewer from "./AttachmentViewer";
import { fetchDropdownByCategoryWise } from "../../service/DropdownService";

const Attachment = () => {
  const [dropdownList, setDropdownList] = useState([]);

  useEffect(() => {
    getCategories();
  }, []);

  const getCategories = async () => {
    try {
      const data = await fetchDropdownByCategoryWise("HealthCare Category");
      const sortedData = data.sort((a, b) => a.title.localeCompare(b.title));
      setDropdownList(sortedData);
    } catch (err) {
      console.error("Failed to fetch dropdown list:", err);
    }
  };

  return (
    <>
      <a href="javascript:;" id="return-to-top">
        <i className="fas fa-angle-double-up"></i>
      </a>
      <Header />
      <div className="container-fluid banner-marquee-container">
        <div className="row marquee-row">
          <marquee
            className="marquee-announcement-home-page"
            behavior="scroll"
            direction="left"
            scrollamount="8"
          >
            <div style={{ display: "inline-block", whiteSpace: "nowrap" }}>
              <span role="img" aria-label="announcement" className="fs-5 me-2">
                📢
              </span>
              <span className="fw-bold ">
                This web vvrhcs has many Healthcare sites to register your name
                and company please contact us-
                <a
                  href="#"
                  style={{
                    textDecoration: "none",
                    color: "#ffffff",
                    marginLeft: "10px",
                  }}
                >
                  <span>
                    <i className="fas fa-phone me-2"></i>
                  </span>
                  04362 - 238 235
                </a>
              </span>
            </div>
          </marquee>
        </div>
      </div>
      <div className="blog-page-main-container float_left pt-2">
        <div className="container-fluid">
          <div className="row">
            <div className="col-lg-9 col-md-12 col-sm-12 col-12">
              <AttachmentViewer />
            </div>

            <div className="col-lg-3 col-md-12 col-sm-12 col-12">
              <aside className="blog-right-sidebar resp-30">
                <div className=" p-4 " style={{ background: "#00B3FF" }}>
                  <h4 className="fw-bold mb-4 text-white">CATEGORIES</h4>

                  <ul className="list-unstyled">
                    {dropdownList.map((item, index) => (
                      <CategoryItem category={item.title} key={index} />
                    ))}
                  </ul>
                </div>
              </aside>
            </div>
          </div>
        </div>
      </div>

      <UserFooter />
    </>
  );
};

export default Attachment;

const CategoryItem = ({ category }) => (
  <li className="mb-2">
    <div className="d-flex align-items-center gap-2">
      <i className="fas fa-heartbeat fa-1x text-white"></i>
      <Link
        to={`/category/${category}`}
        className=" text-white text-decoration-none"
      >
        {category}
      </Link>
    </div>
  </li>
);
